/* ASJ CUSTOM — Hero Slideshow controller. No external libraries.
   Accessible: keyboard arrows, focusable controls, ARIA, an explicit pause/play
   toggle (WCAG 2.2.2), pause on hover/focus, and respects prefers-reduced-motion
   (no autoplay/motion). */
(function () {
  if (window.customElements && customElements.get('asj-hero-slideshow')) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AsjHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.asj-hero__slide'));
      if (this.slides.length <= 1) { this._showOnly0(); return; }
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.asj-hero__dot'));
      this.playBtn = this.querySelector('.asj-hero__playpause');
      this.index = 0;
      this.interval = parseInt(this.getAttribute('data-interval'), 10) || 6000;
      this.autoplaySetting = this.getAttribute('data-autoplay') === 'true';
      // Explicit play state. Off by default under reduced-motion; the user can
      // still opt in with the play button.
      this.playing = this.autoplaySetting && !reduceMotion;
      this.hoverFocus = false;
      this.timer = null;

      var self = this;
      var prev = this.querySelector('.asj-hero__arrow--prev');
      var next = this.querySelector('.asj-hero__arrow--next');
      if (prev) prev.addEventListener('click', function () { self._prev(); });
      if (next) next.addEventListener('click', function () { self._next(); });

      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { self._goTo(i, true); });
      });

      if (this.playBtn) {
        this.playBtn.addEventListener('click', function () { self._togglePlay(); });
      }

      this.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { self._prev(); }
        else if (e.key === 'ArrowRight') { self._next(); }
      });

      // Pause on hover/focus; resume only if the visitor has not explicitly paused.
      this.addEventListener('mouseenter', function () { self.hoverFocus = true; self._stop(); });
      this.addEventListener('mouseleave', function () { self.hoverFocus = false; self._start(); });
      this.addEventListener('focusin', function () { self.hoverFocus = true; self._stop(); });
      this.addEventListener('focusout', function () { self.hoverFocus = false; self._start(); });

      this._goTo(0, false);
      this._updatePlayBtn();
      this._start();
    }

    disconnectedCallback() { this._stop(); }

    _showOnly0() {
      var s = this.querySelector('.asj-hero__slide');
      if (s) s.classList.add('is-active');
    }

    _goTo(i, fromUser) {
      this.index = (i + this.slides.length) % this.slides.length;
      for (var s = 0; s < this.slides.length; s++) {
        var active = s === this.index;
        this.slides[s].classList.toggle('is-active', active);
        this.slides[s].setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      for (var d = 0; d < this.dots.length; d++) {
        this.dots[d].setAttribute('aria-current', d === this.index ? 'true' : 'false');
      }
      // Arrow/dot navigation just resets the interval so the new slide gets full time.
      if (fromUser && this.playing && !this.hoverFocus) { this._stop(); this._start(); }
    }

    _next() { this._goTo(this.index + 1, true); }
    _prev() { this._goTo(this.index - 1, true); }

    _togglePlay() {
      this.playing = !this.playing;
      if (this.playing) { this._start(); } else { this._stop(); }
      this._updatePlayBtn();
    }

    _updatePlayBtn() {
      if (!this.playBtn) return;
      this.playBtn.classList.toggle('is-paused', !this.playing);
      var label = this.playing
        ? (this.playBtn.getAttribute('data-label-pause') || 'Pause slideshow')
        : (this.playBtn.getAttribute('data-label-play') || 'Play slideshow');
      this.playBtn.setAttribute('aria-label', label);
    }

    _start() {
      if (!this.playing || this.hoverFocus || this.timer) return;
      var self = this;
      this.timer = setInterval(function () { self._goTo(self.index + 1, false); }, this.interval);
    }
    _stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  }

  customElements.define('asj-hero-slideshow', AsjHeroSlideshow);
})();
